import { random } from 'lodash';
import Configs from '../../../configs/Configs';
import Selector from '../gui/selector/Selector';
import Session from '../session/Session';
import Hero from './hero/Hero';

const POSITIONS = [
    { x: 0, y: 190 },
    { x: 0, y: 190 },
];

export default class Heroes extends Phaser.GameObjects.Container {
    private heroes: Hero[] = [];
    private selectedHeroId: number = 0;

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);
        this.scene.layers.heroes.add(this);

        this.setupHeroes();
        this.setupListeners();

        this.scene.events.emit(Selector.EVENTS.HERO_SELECTED, 0);
    }

    // static get EVENTS() {
    //     return EVENTS;
    // }

    setupHeroes() {
        let centerX = this.scene.cameras.main.centerX;
        let centerY = this.scene.cameras.main.centerY + 150;

        for (let i = 0; i < POSITIONS.length; i++) {
            let shift = i === 0 ? -this.scene.cameras.main.width : 0;

            let x = centerX + shift; //POSITIONS[i].x;
            let y = centerY + POSITIONS[i].y;

            // let config = Session.Instance.heroes[i];
            // config.attackSpeed = Configs.getHeroAttackSpeed(i);

            const baseConfig = Session.Instance.heroes[i];
            const config = {
                ...baseConfig,
                attackSpeed: Configs.getHeroAttackSpeed(i),
            };

            let hero = new Hero(this.scene, x, y, config);
            this.add(hero);

            this.heroes.push(hero);
        }

        this.heroes[0].selected = false;
        this.heroes[1].selected = false;
    }

    setupListeners() {
        this.scene.events.on(Selector.EVENTS.HERO_SELECTED, this.onHeroSelected, this);
    }

    onHeroSelected(heroId: number) {
        for (let hero of this.heroes) hero.deselect();
        this.heroes[heroId].select();
    }

    selectedHeroAttack() {
        if (!this.selectedHero!.canAttack) return null;
        this.selectedHero!.attack();

        let heroId = this.selectedHero!.id;
        let { damage, isCrit } = this.selectedHero!.damage;

        return { damage, isCrit, heroId };
    }

    get selectedHero() {
        return this.heroes.find((h) => h.selected);
    }

    get enrageDamage() {
        let { damage } = this.heroes[1].damage;
        return damage;
    }

    destroy() {
        this.scene.events.off(Selector.EVENTS.HERO_SELECTED, this.onHeroSelected, this);
        super.destroy();
    }
}
